module.exports = __webpack_public_path__ + "static/media/Orinocco95.ab67fcf1.jpg";